import { render, staticRenderFns } from "./MoveCustomersToProduct.vue?vue&type=template&id=07c6a341&scoped=true&"
import script from "./MoveCustomersToProduct.vue?vue&type=script&lang=ts&"
export * from "./MoveCustomersToProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c6a341",
  null
  
)

export default component.exports